<template>
<div class="DetailMaterial">
  <div class="page" >
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class=" d-flex align-center pb-4 mb-4">
      <h1 class="font-lg">{{education.title}}</h1>
    </div>
    <div class="DetailMaterial__body">
      <div class="video" v-if="education.video_url">
        <iframe
          v-if="education.video_url"
          height="290px"
          width="100%"
          class="video-frame"
          :src="education.video_url"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        >
        </iframe>
      </div>
      <div class="text text-pre-wrap">{{ education.text }}</div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/**
 * Компонент: DetailMaterial
 * Описание:
 */
export default {
  name: 'DetailMaterial',

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      education: 'education/Education/getCurrentEducation',
    }),
    educationId() {
      return this.$route.params.educationId;
    },
    breadcrumbs() {
      return [
        { title: 'Обучающие материалы', url: '/training-materials' },
        { title: this.education.title, url: '' },
      ];
    },
  },

  watch: {},

  created() {
  },

  async mounted() {
    await this.attemptFetchDetailEducation();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchEducation: 'education/Education/fetchDetailEducation',
    }),
    async attemptFetchDetailEducation() {
      if (this.educationId) {
       const res = await this.fetchEducation({ id: this.educationId });
        if (!res.success && res.err && res.err.status === 404) {
         await this.$router.push('/404');
        }
        if (res.success && res.data.status !== 'published') {
           await this.$router.push('/training-materials');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.DetailMaterial {
  /* Стили компонента */
  &__body {
    background: white;
    border-radius: 8px;
    padding: 16px 24px;
    & .video{
      max-width: 70%;
    }
    & .text{
      max-width: 70%;
    }
  }
}
</style>
